
/*
@author govind dindewad
*/
import axios from "axios";
import apiUrl from "./api";

/*
/ @author govind dindewad
/ dt:- 01-03-2025
/ Function to get the list of feedback based on various parameters
*/

async function getFeedbackList({ searchKey = '', page = 0 }) {
    const token = window.localStorage.getItem('token');

    try {
        // Sending a GET request to the API with dynamic query parameters for search filters
        const response = await axios.get(`${apiUrl}secure/feedback/retain-all-feedback?pageNumber=${page}&searchKey=${searchKey}`, {
            // Adding the Authorization header with the token for secure API access
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });

        // Returning the successful response from the API
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        // Handling errors by returning the error response (in case of failure)
        return error.response;
    }
}

/*
/ @author govind dindewad
/ dt:- 21-03-2025
/ Function to get the list of feedback based on various parameters
*/

async function putFeedbackAcknowledge({ userId, feedbackId, flag }) {
    const token = window.localStorage.getItem('token');

    try {
        // Sending a GET request to the API with dynamic query parameters for search filters
        const response = await axios.put(`${apiUrl}secure/feedback/feedback-action?userId=${userId}&feedbackId=${feedbackId}&flag=${flag}`, {}, {
            // Adding the Authorization header with the token for secure API access
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });

        // Returning the successful response from the API
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        // Handling errors by returning the error response (in case of failure)
        return error.response;
    }
}



export { getFeedbackList, putFeedbackAcknowledge };